var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRpcStatusMediumLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.16663H4.66667V14.5H2V9.16663Z",
    fill: "#D69003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.5H9.33366V14.5H6.66699V6.5Z",
    fill: "#D69003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 2.5H13.9997V14.5H11.333V2.5Z",
    fill: "rgba(13, 26, 22, 0.07)",
    fillOpacity: 1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpcStatusMediumLight);
export default __webpack_public_path__ + "static/media/rpc-status-medium-light.3b03d137fa23b68a2b3198a0a5c8ab43.svg";
export { ForwardRef as ReactComponent };